import { render, staticRenderFns } from "./paymentVoucher.vue?vue&type=template&id=bc294232&scoped=true"
import script from "./paymentVoucher.vue?vue&type=script&lang=js"
export * from "./paymentVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc294232",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc294232')) {
      api.createRecord('bc294232', component.options)
    } else {
      api.reload('bc294232', component.options)
    }
    module.hot.accept("./paymentVoucher.vue?vue&type=template&id=bc294232&scoped=true", function () {
      api.rerender('bc294232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largeOrderManagement/component/paymentVoucher.vue"
export default component.exports